export default "__VITE_ASSET__SBtU9put__"